import Model from './Model'

export default class Variation extends Model {

    schema() {
        return {
            id: null,
            mf_prefix: null,
            shop_id: null,
            slug: null,
            ean13: null,
            upc: null,
            external_ref: null,
            motocloud_ref: null,
            out_of_stock_message: null,
            quantity: null,
            has_stock: false,
            indexed: false,
            activated: false,
            dale_autorized: false,
            popularity: null,
            loader: false,
            editMode: false,
            inlineLoader: false,
            ref_kwisatz: null,
            price_speedway: null,
            paht: null,
            date_dispo_pim: null,
            datasEditInline: {},
            deleted_at: null,
            manufacturer_ref: null,
        }
    }

    setEditMode() {
        this.editMode = true
        this.datasEditInline = {
            variation_value_id: this.variation_value_id,
            ean13: this.ean13,
            upc: this.upc,
            shop_id: this.shop_id,
            external_ref: this.external_ref,
            mf_price_public: this.mf_price_public,
            price_speedway: this.price_speedway,
            paht: this.paht,
            ref_kwisatz: this.ref_kwisatz,
            date_dispo_pim: this.date_dispo_pim,
            manufacturer_ref: this.manufacturer_ref,
        }
    }

    cancelEditMode() {
        this.editMode = false
    }


    saveEditMode() {
        this.cancelEditMode()
        return this.datasEditInline
    }


}
